import { computed } from 'vue';
import { createRouter, createWebHistory } from 'vue-router';
// import HomeView from '../views/HomeView.vue'
import Main from '@/pages/Main.vue';
import Bar from '@/pages/Bar.vue';
import CocktailPage from '@/pages/CocktailPage.vue';
import Login from '@/pages/Login.vue';
import Singin from '@/pages/Singin.vue';
import Profile from '@/pages/Profile.vue';
import Top from '@/pages/Top.vue';
import Barman from '@/pages/Barman.vue';
import BarmanEditor from '@/pages/BarmanEditor.vue';


const routes = [
  {
    path: '/',
    component: Main
  },
  {
    path: '/bar',
    component: Bar
  },
  {
    path: '/bar/cocktail/:cid',
    component: CocktailPage
  },
  {
    path: '/auth/log_in',
    component: Login
  },
  {
    path: '/auth/sing_in',
    component: Singin
  },
  {
    path: '/profile',
    component: Profile
  },
  {
    path: '/top',
    component: Top
  },
  {
    path: '/barman',
    component: Barman
  },
  {
    path: '/barman/cocktails',
    component: BarmanEditor
    // component: BarmanCocktails
    // component: CocktailsEditor
  }

  // {
  //   path: '/auth/sing_in',
  //   component: Singin
  // }
  // {
  //   path: '/',
  //   name: 'home',
  //   component: HomeView
  // },
  // {
  //   path: '/about',
  //   name: 'about',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  // }
]

const router = createRouter({
  routes,
  history: createWebHistory(process.env.BASE_URL),
})

export default router;
